import { useEffect, useMemo, useState } from "react";
import ArrowLeftLineIcon from "remixicon-react/ArrowLeftLineIcon";
import { useForm, Controller } from "react-hook-form";
import ReactSelect from "react-select";
import { useDispatch, useSelector } from "react-redux";
import Papa from "papaparse";
import CheckLineIcon from "remixicon-react/CheckLineIcon";
import CloseLineIcon from "remixicon-react/CloseLineIcon";
import DownloadCloud2sLineIcon from "remixicon-react/DownloadCloud2LineIcon";
import CardLayout from "../../../components/utils/CardLayout";
import Button from "../../../components/utils/Button";
import Table from "../../../components/utils/Table";
import {
  isKeyUnique,
  validateIMEI,
  validateSNo,
  validatePin,
  selectCharacters,
  twoDigitDecimal,
} from "../../../helpers/commonFunction";
import activationRequestActions from "../../../redux/activationRequest/actions";
import ChatractivationActions from "../../../redux/chatrActivation/actions";
import "../ActivationRequest.css";
import Alert from "../../../components/utils/Alert";
import planAction from "../../../redux/plan/actions";
import shortCodeAction from "../../../redux/shortCodeData/actions";
import ChatrRechargeActions from "../../../redux/Chatr Recharge Request/actions";
import RechargePlanAction from "../../../redux/chatrRechargePlan/actions";

// const { addChatrBulkActivation, resetChatrValidateMessage } =
//   ChatractivationActions;

const { addChatrBulkRecharge, resetChatrValidateMessage } =
  ChatrRechargeActions;

const BASE_URL = process.env.REACT_APP_SITE_BASE_URL;

// const { getPlan } = planAction;
const { getChatrRechargePlanData } = RechargePlanAction;

const ChatrBulkRecharge = ({ back, searchData }) => {
  const dispatch = useDispatch();
  const { networkResult } = useSelector((state) => state.network);
  // const { planResult } = useSelector((state) => state.plan);
  const { getRechargePlanResult } = useSelector(
    (state) => state.chatrRechargePlan,
  );
  const { tokenData } = useSelector((state) => state.auth);
  // const {
  //   addChatrBulkActivationMessage,
  //   addChatrBulkActivationError,
  //   addChatrBulkActivationLoading,
  // } = useSelector((state) => state.chatrActivation);
  const {
    addChatrBulkRechargeMessage,
    addChatrBulkRechargeError,
    addChatrBulkRechargeLoading,
  } = useSelector((state) => state.chatrRecharge);
  const [csvError, setCsvError] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState([]);
  const [previewData, setPreviewData] = useState([]);
  const [previewSuccessData, setPreviewSuccessData] = useState([]);
  const [previewFailedData, setPreviewFailedData] = useState([]);
  const [showPreviewType, setShowPreviewType] = useState(2);
  const [rechargeRequests, setRechargeRequests] = useState([]);
  const [previewSuccessCount, setPreviewSuccessCount] = useState(0);
  const [csvLimitError, setCsvLimitError] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState("");
  const [alertText, setAlertText] = useState("");
  const [networkId, setNetworkId] = useState(0);
  const [simType, setSimType] = useState(0);
  const [accountBalance, setAccountBalance] = useState(0);

  const RECHARGE_LIMIT = 100;

  useEffect(() => {
    tokenData &&
      tokenData.length > 0 &&
      tokenData.map((data) => {
        setAccountBalance(data.AccountBalance);
      });
  }, [tokenData]);

  useEffect(() => {
    if (csvLimitError !== null && csvLimitError !== undefined) {
      displayAlert(csvLimitError, "alert-danger");
    }
    if (
      addChatrBulkRechargeError !== null &&
      addChatrBulkRechargeError !== undefined
    ) {
      displayAlert(addChatrBulkRechargeError, "alert-danger");
    }
  }, [csvLimitError, addChatrBulkRechargeError]);

  useEffect(() => {
    if (addChatrBulkRechargeMessage) {
      back();
      dispatch(resetChatrValidateMessage());
    }
  }, [addChatrBulkRechargeMessage]);

  useEffect(() => {
    if (previewData.length > 0) {
      let successPreview = previewData.filter((item) => item.Status == 1);
      let failedPreview = previewData.filter((item) => item.Status == 0);
      setPreviewSuccessData(successPreview);
      setPreviewFailedData(failedPreview);
    }
  }, [previewData]);

  useEffect(() => {
    let selectedNetwork =
      networkResult &&
      networkResult.filter((network) => network.ID == networkId);
    // dispatch(getPlan(networkId));
    dispatch(getChatrRechargePlanData(networkId));
  }, [networkId]);

  useEffect(() => {
    if (getRechargePlanResult.length > 0 && networkResult.length > 0) {
      setSelectedPlan(getRechargePlanResult);
    } else {
      setSelectedPlan([]);
    }
  }, [getRechargePlanResult]);

  const filteredNetworkResult = useMemo(() => {
    return networkResult?.filter((network) => network.ID == 1) || [];
  }, [networkResult]);

  useEffect(() => {
    if (filteredNetworkResult.length > 0) {
      setNetworkId(1);
      bulkRechargeSetValue("networkID", 1);
      // dispatch(getPlan(1));
      dispatch(getChatrRechargePlanData(1));
    }
  }, [filteredNetworkResult]);

  const displayAlert = (text, type) => {
    setAlertText(text);
    setAlertType(type);
    setShowAlert(true);
  };

  const alertCancel = () => {
    setShowAlert(false);
    setAlertText("");
    setAlertType("");
  };

  const {
    register: bulkRechargeRegister,
    handleSubmit: bulkRechargeHandleSubmit,
    formState: { errors: bulkRechargeError },
    watch: bulkRechargeWatch,
    reset: bulkRechargeReset,
    setValue: bulkRechargeSetValue,
    setError: bulkRechargeSetError,
    clearErrors: bulkRechargeClearErrors,
    control: bulkRechargecontrol,
  } = useForm({
    defaultValues: {
      networkID: "",
      planID: "",
    },
  });

  const planIDWached = bulkRechargeWatch("planID");

  const previewColumns = [
    { displayName: "Mobile NUMBER", key: "MobileNumber" },
    { displayName: "REASON", key: "Reason" },
    { displayName: "VALID", key: "Valid" },
  ];

  const handleNetwork = (e) => {
    e.preventDefault();
    bulkRechargeReset({
      planID: "",
      uploadedFile: "",
    });
    setPreviewData([]);
    setRechargeRequests([]);
    setPreviewSuccessData([]);
    setPreviewFailedData([]);
    // dispatch(getPlan(e.target.value));
    dispatch(getChatrRechargePlanData(e.target.value));
    setNetworkId(e.target.value);
  };

  const handleSelectPlan = (e) => {
    const planId = e.target.value;
    if (planId) {
      bulkRechargeSetValue("planID", planId);
    }
    bulkRechargeSetValue("uploadedFile", "");
    setPreviewData([]);
    setRechargeRequests([]);
    setPreviewSuccessData([]);
    setPreviewFailedData([]);
    setPreviewSuccessCount(0);
    bulkRechargeClearErrors(["uploadedFile"]);
  };

  const handlePreviewTableData = (id) => {
    setShowPreviewType(id);
  };

  const handleAddBulkRecharge = (data) => {
    data.totalRequests = rechargeRequests.length;
    const approvedRows = rechargeRequests.filter((item) => item.status === 1);
    const failedRows = rechargeRequests.filter((item) => item.status === 0);
    data.successRequests = approvedRows.length;
    data.failedRequestData = failedRows;
    data.failedRequest = failedRows.length;
    data.rechargeRequests = approvedRows;
    
    const selectedPlanData = getRechargePlanResult.find(
       (item) => Number(item.PlanID) === Number(data.planID),
     );
    const price = Number(selectedPlanData?.RechargePrice) || 0;
    // console.log("price: ", selectedPlanData?.RechargePrice);

    const purchaseAmount = price * approvedRows.length;
    data.purchaseAmount = purchaseAmount;
    delete data.uploadedFile;
    if (approvedRows.length <= 0) {
      alert("Please upload valid data");
      return;
    }
    if (Number(accountBalance) >= Number(data.purchaseAmount)) {
      // console.log("Final Data:", data);
      dispatch(addChatrBulkRecharge(data, searchData));
    } else {
      alert("insufficient fund");
    }
  };

  const estimatedAmountColumn = [
    { displayName: "Total Recharge", key: "tRecharge" },
    { displayName: "Per Recharge (Plan)", key: "pRecharge" },
    { displayName: "Total Paid", key: "tPaid" },
  ];

  const estimatedAmountDataSource = useMemo(() => {
    // debugger
    if (!planIDWached) {
      return [
        {
          tRecharge: 0,
          pRecharge: "$0.00",
          tPaid: "$0.00",
        },
      ];
    }

    const selectedPlan = getRechargePlanResult.find(
      (item) => Number(item.PlanID) === Number(planIDWached),
      // (item) => item.PlanName == planIDWached,
    );

    if (!selectedPlan) {
      return [
        {
          tRecharge: previewSuccessData.length,
          pRecharge: "$0.00",
          tPaid: "$0.00",
        },
      ];
    }

    const price = Number(selectedPlan.RechargePrice) || 0;
    const totalRecharge = previewSuccessData.length;
    const paidTotal = price * totalRecharge;
    // console.log("Plan Price", price);

    return [
      {
        tRecharge: totalRecharge,
        pRecharge: `$${twoDigitDecimal(price)}`,
        tPaid: `$${twoDigitDecimal(paidTotal)}`,
      },
    ];
  }, [planIDWached, previewSuccessData.length, getRechargePlanResult]);

  const handleTextareaChange = (val) => {
    bulkRechargeClearErrors(["uploadedFile"]);
    setPreviewData([]);
    setRechargeRequests([]);
    setPreviewSuccessCount(0);
    setRechargeRequests([]);
    const dataArr =
      val !== "" ? val.split("\n").map((item) => item.replace(/\s/g, "")) : [];

    if (dataArr.length > 100) {
      bulkRechargeSetError("uploadedFile", {
        type: "custom",
        message: "Maximum 100 Mobile numbers are allowed",
      });
      return false;
    }

    if (new Set(dataArr).size !== dataArr.length) {
      bulkRechargeSetError("uploadedFile", {
        type: "custom",
        message: "Data contain duplicate Mobile number",
      });
      return false;
    }

    const dataSource = dataArr.map((item) => {
      const mobileNumber = item;
      let error = false;
      let reason = "Valid";
      if (
        !/^\d+$/.test(mobileNumber) ||
        mobileNumber.length < 10 ||
        mobileNumber.length > 10
      ) {
        reason = "Invalid Mobile Number";
        setCsvError(true);
        error = true;
      }

      if (!error) {
        setPreviewSuccessCount((pre) => pre + 1);
      }

      return {
        MobileNumber: mobileNumber,
        Reason: reason,
        Valid: error ? (
          <CloseLineIcon color="#e74c3c" />
        ) : (
          <CheckLineIcon color="#2ecc71" />
        ),
        Status: error ? 0 : 1,
      };
    });
    setPreviewData(dataSource);
    let requestData = dataArr.map((item) => {
      const mobileNumber = item;
      let error = false;
      let reason = "Valid";
      if (
        !/^\d+$/.test(mobileNumber) ||
        mobileNumber.length < 10 ||
        mobileNumber.length > 10
      ) {
        reason = "Invalid Mobile Number";
        setCsvError(true);
        error = true;
      }
      return {
        MSISDN: mobileNumber,
        status: error ? 0 : 1,
        reason,
      };
    });
    setRechargeRequests(requestData);
  };

  return (
    <CardLayout title="Add Chatr Recharge">
      <div className="row mb-3">
        <div className="col-lg-12 text-right">
          <button
            type="button"
            onClick={() => back()}
            className={`btn btn-danger font-weight-bold`}
          >
            <ArrowLeftLineIcon size={16} />
            Back
          </button>
        </div>
      </div>

      <div className="container">
        <form onSubmit={bulkRechargeHandleSubmit(handleAddBulkRecharge)}>
          {/* FORM FIELDS STARTS FROM HERE */}
          <div className="form-row">
            <div className="col-md-3 mb-3">
              <label className="ml-2">
                {" "}
                Network <span className="text-danger">*</span>
              </label>
              <select
                className="form-control"
                placeholder="Select Network"
                name="networkID"
                {...bulkRechargeRegister("networkID", {
                  required: "Network is Required",
                })}
                onChange={(e) => {
                  handleNetwork(e);
                }}
              >
                {/* <option value="" key="0" disabled>
                  Select
                </option> */}
                {filteredNetworkResult.length > 0 &&
                  filteredNetworkResult.map((network) => (
                    <option name="network" value={network.ID} key={network.ID}>
                      {network.NetworkName}
                    </option>
                  ))}
              </select>
              {bulkRechargeError && bulkRechargeError.networkID && (
                <div className="invalid-feedback">
                  {bulkRechargeError.networkID.message}
                </div>
              )}
            </div>

            <div className="col-md-3 mb-3">
              <label className="ml-2">
                {" "}
                Plan <span className="text-danger">*</span>
              </label>
              <select
                className="form-control"
                placeholder="Select Plan"
                name="planID"
                {...bulkRechargeRegister("planID", {
                  required: "Plan is Required",
                })}
                onChange={(e) => handleSelectPlan(e)}
              >
                <option value="" disabled key="0">
                  Select
                </option>
                {selectedPlan &&
                  selectedPlan.length > 0 &&
                  selectedPlan.map((plan) => (
                    <option name="plan" value={plan.PlanID} key={plan.PlanID}>
                      {" "}
                      {plan.PlanName}{" "}
                    </option>
                  ))}
              </select>
              {bulkRechargeError && bulkRechargeError.planID && (
                <div className="invalid-feedback">
                  {bulkRechargeError.planID.message}
                </div>
              )}
            </div>

            {networkId && planIDWached && (
              <div className="col-md-6 mb-3">
                <label className="ml-2">
                  {" "}
                  Mobile Number <span className="text-danger">*</span>{" "}
                </label>
                <textarea
                  className="form-control"
                  rows="6"
                  placeholder="Enter Mobile Number"
                  {...bulkRechargeRegister("uploadedFile")}
                  onChange={(e) => handleTextareaChange(e.target.value)}
                />

                <small className="text-muted">
                  Enter one Mobile Number per line. Maximum {RECHARGE_LIMIT}{" "}
                  Mobile Numbers allowed.
                </small>

                {bulkRechargeError?.uploadedFile && (
                  <div className="text-danger mt-1">
                    {" "}
                    {bulkRechargeError.uploadedFile.message}{" "}
                  </div>
                )}
              </div>
            )}
          </div>
          {/* FORM FIELDS END HERE */}

          {previewData.length > 0 && (
            <>
              <hr />
              <div className="row p-0 m-0" style={{ cursor: "pointer" }}>
                <div
                  className="col-md-4 d-flex justify-content-around align-items-center py-3 preview-box"
                  onClick={() => {
                    handlePreviewTableData(2);
                  }}
                >
                  <h4>Total Submitted : {previewData.length}</h4>
                </div>
                <div
                  className="col-md-4 d-flex justify-content-around align-items-center preview-box"
                  onClick={() => {
                    handlePreviewTableData(1);
                  }}
                >
                  <h4 className="text-success">
                    Valid : {previewSuccessCount}
                  </h4>
                </div>
                <div
                  className="col-md-4 d-flex justify-content-around align-items-center preview-box"
                  onClick={() => {
                    handlePreviewTableData(0);
                  }}
                >
                  <h4 className="text-danger">
                    Invalid : {previewData.length - previewSuccessCount}
                  </h4>
                </div>
              </div>
              <div className="col-md-12 mb-3 p-0">
                <Table
                  columns={previewColumns}
                  data={
                    showPreviewType == 1
                      ? previewSuccessData
                      : showPreviewType == 0
                        ? previewFailedData
                        : previewData
                  }
                  pagination={false}
                />
              </div>

              <div className="col-md-12 mb-3 p-0">
                <h3 className="text-dark">Price details</h3>
                <Table
                  columns={estimatedAmountColumn}
                  loading={false}
                  data={estimatedAmountDataSource}
                  pagination={false}
                />
              </div>
            </>
          )}
          <hr />

          {showAlert && (
            <Alert type={alertType} text={alertText} closeBtn={alertCancel} />
          )}

          <div className="text-right row">
            <div className="col-md-12">
              <button
                type="button"
                className="btn btn-secondary mr-2"
                onClick={() => back()}
              >
                Close
              </button>
              {rechargeRequests.filter((item) => item.status === 1).length >
              0 ? (
                <Button
                  title="Submit"
                  style="minWidth:80px"
                  loading={addChatrBulkRechargeLoading}
                  buttonClass="btn btn-primary"
                  buttonType="submit"
                />
              ) : (
                ""
              )}
            </div>
          </div>
        </form>
      </div>
    </CardLayout>
  );
};

export default ChatrBulkRecharge;
